/* eslint-disable no-unused-vars */
var jic = {
    compress: function (t, e, n) {
        var a = "image/jpeg";
        "undefined" != typeof n && "png" == n && (a = "image/png");
        var r = document.createElement("canvas");
        (r.width = t.naturalWidth), (r.height = t.naturalHeight);
        var o = (r.getContext("2d").drawImage(t, 0, 0), r.toDataURL(a, e / 100)),
            s = new Image();
        return (s.src = o), s;
    },
    upload: function (t, e, n, a, r, o, s, i) {
        void 0 === XMLHttpRequest.prototype.sendAsBinary &&
            (XMLHttpRequest.prototype.sendAsBinary = function (t) {
                var e = Array.prototype.map.call(t, function (t) {
                    return 255 & t.charCodeAt(0);
                });
                this.send(new Uint8Array(e).buffer);
            });
        var p = "image/jpeg";
        ".png" == a.substr(-4) && (p = "image/png");
        var u = t.src;
        u = u.replace("data:" + p + ";base64,", "");
        var d = new XMLHttpRequest();
        d.open("POST", e, !0);
        var c = "someboundary";
        if ((d.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + c), i && "object" == typeof i)) for (var f in i) d.setRequestHeader(f, i[f]);
        s &&
            s instanceof Function &&
            (d.upload.onprogress = function (t) {
                t.lengthComputable && s((t.loaded / t.total) * 100);
            }),
            d.sendAsBinary(["--" + c, 'Content-Disposition: form-data; name="' + n + '"; filename="' + a + '"', "Content-Type: " + p, "", atob(u), "--" + c + "--"].join("\r\n")),
            (d.onreadystatechange = function () {
                4 == this.readyState && (200 == this.status ? r(this.responseText) : this.status >= 400 && o && o instanceof Function && o(this.responseText));
            });
    },
};

export default jic
